import React from "react";

const PregnancyAssessmentModal = ({ show, onClose, onYes, onYesNoLongerPregnant, onNo }) => {
  if (!show) return null;
  return (
    <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
           {/* <h5 className="modal-title">Pregnancy Assessment</h5>*/}
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <h5 style={{fontSize:"1.5rem"}}>Did this most recent cycle result in a pregnancy?</h5>
            <div className="d-flex flex-column gap-2">
              <button className="win-btn-primary-full" onClick={onYes}>Yes</button>
              <button className="win-btn-secondary-full" onClick={onYesNoLongerPregnant}>Yes, but I'm no longer pregnant</button>
              <button className="win-btn-secondary-full" onClick={onNo}>No</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PregnancyAssessmentModal;
